import React from 'react';
import { images } from '../../assets';
import { Box } from '@mui/material';

interface Props {
  sort: string;
  setSort: (sort: string) => void;
}
const SortButton = ({ sort, setSort }: Props) => {
  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // width: '40px',
        height: '40px',
        backgroundColor: '#212121B2',
        cursor: 'pointer',
        borderRadius: '2px',
        gap: 4,
        paddingLeft: 8,
        paddingRight: 8,
      }}
      onClick={() => setSort(sort === 'desc' ? 'asc' : 'desc')}
    >
      <img src={images.filterIcon} alt="filter" width={24} height={24} onClick={() => {}} />
      <p
        style={{
          fontSize: '18px',
          fontWeight: 400,
        }}
      >
        {sort !== 'desc' ? 'Oldest' : 'Newest'}
      </p>
    </Box>
  );
};

export default SortButton;